
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexZuAQ61OkphqbbG41i73gbVFXDVXHuTtb7_w8UIzMlGAMeta } from "/azp/agent/_work/11/s/frontend/pages/user/index.vue?macro=true";
import { default as indexfkqj010CLthpL1UH8Z36Gk79vgPabQ31_na_lkkaTEQMeta } from "/azp/agent/_work/11/s/frontend/pages/user/downloads/index.vue?macro=true";
import { default as delegate_45account7P7NZc3LOPd87PeZGaTxSDUqjBA4f9ie__Mfpp_GZ48Meta } from "/azp/agent/_work/11/s/frontend/pages/user/delegate-account.vue?macro=true";
import { default as indexDgfYRzGvQ_eU2ZMBjZJ8m_cnJ0hTT22mtvpupJVfKwgMeta } from "/azp/agent/_work/11/s/frontend/pages/user/account-details/index.vue?macro=true";
import { default as index_RS3m0CnYSVGLKbqYlWI2zKjL_AOCP7DRzUJ1dQQJt4Meta } from "/azp/agent/_work/11/s/frontend/pages/user/change-password/index.vue?macro=true";
import { default as indexQ0ZyyUUqq57yXspxGJUdKa641_6__PTMzl3sNAhsnQAMeta } from "/azp/agent/_work/11/s/frontend/pages/user/platform-notifications/index.vue?macro=true";
import { default as userUNv7JsFNXFLhP__rvGsQ8E0KYfA5o_a6unklnNMwxbgMeta } from "/azp/agent/_work/11/s/frontend/pages/user.vue?macro=true";
import { default as addIxbHY5AC_ApqqDQT4aOzSiwchfQrGERp_c4Ue6_hMKYMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/jobs/add.vue?macro=true";
import { default as indexPpCqib3t0X7xMIyVAvFOobz6uEO_NaUjw_tgEeTedXgMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/jobs/index.vue?macro=true";
import { default as _91UUID_93bqVdspIlJC0rRLmUdR5w42VDxIetzRF9FDBLmedCmPQMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/jobs/[UUID].vue?macro=true";
import { default as _91_91id_93_93ebR01cbqmLH1OQ6UnRAB5DhrmRu9kjwVeXbcheGXhCIMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/jobs/history/[[id]].vue?macro=true";
import { default as jobs8OH23zClk5LNjLsSFWgFt4Est9SPoEFb0jt6SIFiPNQMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/jobs.vue?macro=true";
import { default as indexSOrjF4ZT_spBvklYHc5XPsXRBABNzJUZlZa81TihWF4Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/index.vue?macro=true";
import { default as addNFI8kpkPNE1_enrlNA72m8h01IKFsDGB3uteAxFbZ5oMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/roles/add.vue?macro=true";
import { default as _91ID_93h_VdHilkXSPOU6QrUVPSKyevctCcOwjCxLo8Q8tFSXYMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/roles/[ID].vue?macro=true";
import { default as index2MDumYFhfM0lD0BDyH8Yp8lAF_nyE8cNF2PGgsRRItgMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/roles/index.vue?macro=true";
import { default as add_BC_EUI_gvumiaOZta4rVje1DIpUnd5lDxiK0UV_UG0Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/roles/authorizations/add.vue?macro=true";
import { default as _91ID_933_g3GWC9xmxZ0aitVDZkDAcydm1LTeldilKghgpDlGMMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/roles/authorizations/[ID].vue?macro=true";
import { default as rolesl_m5VwPATCiO1xi7hdDJIIcqcRjocq8lGLqQobiFXs0Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/roles.vue?macro=true";
import { default as indexXktINc99pDsdhOBk4d9AX7YyHP8B3ppnug6POZJn__wMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/entity/[tab]/index.vue?macro=true";
import { default as entity9ijf22X4N7IFPlIAOOleVdIqndaEIc4vKt1RTIe157kMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/entity.vue?macro=true";
import { default as addT3aou_5yMcS8VySxSwZ_ZiR0yaFLQluPXfRuMOwhhEUMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dataset/add.vue?macro=true";
import { default as index6iXaX3mCqQt_d9WtYSJoklROjUjCg_v9yAy4gSHB5tcMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dataset/index.vue?macro=true";
import { default as _91UUID_93p1RewijEVVRPwNc44SorkrEWyuRJNZyrrxKewAyamZAMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dataset/edit/[UUID].vue?macro=true";
import { default as _91name_93TW3wjt4ExCfkU2WhZiPAWDNQb2U1maUSPWxgtvr5IIEMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dataset/details/[UUID]/[name].vue?macro=true";
import { default as addJB6NeEvtcOZwdZk5KwcMvj7kBtJsEkPO509Y0mI0z7cMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dataset/credentials/[UUID]/add.vue?macro=true";
import { default as indexk2h4fqlK9kNO8JtC_7wmZA_wLIIB4UkoGUduun6P1akMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dataset/credentials/[UUID]/index.vue?macro=true";
import { default as _91_91name_93_93tLVhOesy6ASU0FQdJarXCFcULOgKerrIiu45xlVvr88Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/dataset/manage/[[UUID]]/[[name]].vue?macro=true";
import { default as _91credentialUUID_93DloCdfR9wNcG5mUTSdnWjwXL_UiWIVCZKFKustxS28YMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dataset/credentials/[UUID]/[credentialUUID].vue?macro=true";
import { default as datasetowZBtxpWvtzPIAqOSKhnb7JHqXfAUEjpYIOYPycr6Y8Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/dataset.vue?macro=true";
import { default as indexyYOIn4U4YuAXScW7on6IOv4IzIFyspgmQb5_ItfjSFgMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/objects/index.vue?macro=true";
import { default as _91UUID_93BbtPTDf4_kZ9I2ZRsSSKzqaydhHJBYrz6RhnA3crDBwMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/objects/overview/[UUID].vue?macro=true";
import { default as addqcgp2cYAnakvOREJJgUNMgZyFLyJ_CuSbxUfG1AvhUsMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/records/add.vue?macro=true";
import { default as _91_91recordUUID_93_934otNmFykkWkegrwkb11cMIDPoPkeNbhmhoqdPzZualcMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/records/[[recordUUID]].vue?macro=true";
import { default as recordsG80J9Ny2HXF48ylVuykOmAGT4SqtDY__cS3Vgb0HJjIMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/records.vue?macro=true";
import { default as _91_91templateUUID_93_935dTSxmyomjAmYIvPk7ugij1rOf5EBaGiy15N1jy4wv0Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/templates/[[templateUUID]].vue?macro=true";
import { default as templatesFPwqm7Ft6YWnA8N3ED2f9o17dfXytTl_14wvh_f6j4QMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/templates.vue?macro=true";
import { default as indexHbsdpSLqiIORpg2daWTW7CKYQBHwTx4sQd9j5AIHNyoMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/display/index.vue?macro=true";
import { default as _91_91tab_93_93SkJFqRiu0mJEnJB1ZX8q5xvMkHr6Z7lh1w1Xm_q_TZcMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/display/[recordUUID]/[[tab]].vue?macro=true";
import { default as _91recordUUID_93sxvL_gNSn67KqTnf3qRFhPMiiJo_9DF9GUKl227YKKAMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/display/[recordUUID].vue?macro=true";
import { default as indexs5XRbkWnoROWeEGjTC_IECLPhh8uW_PtQ5ajXH7b640Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/rest-api-keys/[[UUID]]/index.vue?macro=true";
import { default as rulesklF2zNOo01qLte59l8sBDuV8gftJVPX4MaOwOtwTSIsMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/rest-api-keys/[[UUID]]/rules.vue?macro=true";
import { default as objectsXGIjGPOeTuZQaLISg1AbdgI_DWfHSb_AqBqHvpyvIXUMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/objects.vue?macro=true";
import { default as indexObxFgEaSN2BTuNkENs1Todd5qjveMdpRPGMHSP5iWUkMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/wizards/index.vue?macro=true";
import { default as _91UUID_93t2yIhIQhqIAEaR8hp_cUyWCksPDWAkDdN_R5TpcVrzsMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/wizards/[UUID].vue?macro=true";
import { default as add_45wizardF_k8ewfF2z2aemU6p2Xg6gXbr2si6q3_WjD2gwzlAscMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/wizards/add-wizard.vue?macro=true";
import { default as _91UUID_936IcCuyZ_kxUoST4e8M85PTbaHzX7OMSSRMI3OHob9NoMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/wizards/manage/[UUID].vue?macro=true";
import { default as wizardsjNpKYZD5P_l6Fb5YPuxXwJmMfgv0k4jISZE1cZJsHPcMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/wizards.vue?macro=true";
import { default as index_NxpBfgpPgJllB_Au7DxIGaaOVO8qPTTXa65ZXyJEvcMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/cron-jobs/index.vue?macro=true";
import { default as _91name_93MOG0lcrQMt6f8he2PJ0g7_SiLCFK_xiBSAIBBMXk_voMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/cron-jobs/[name].vue?macro=true";
import { default as cron_45jobsJ1WK8qScqkYKs8R49YxdjnbaBTlZVKqN4SNcDOyWIK8Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/cron-jobs.vue?macro=true";
import { default as addw7GMH_sNatwm_3kjbdjc57cTr7ehnRwh_LN6tnR4DNsMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/languages/add.vue?macro=true";
import { default as indexfwmr7U_V67fG2i6nMBJhIkIsfrCmu9Qh1T1VsyPtT0wMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/languages/index.vue?macro=true";
import { default as addNBYM7UFmo8qtxtJfpvKzKneR9O_TzvYQ4BZqe8ST1KYMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/languages/label-groups/add.vue?macro=true";
import { default as indexOc3DWdtQBWwZaJIGB5IcDUESFFolW9jXcvwO8uUCoScMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/languages/label-groups/index.vue?macro=true";
import { default as _91labelGroupUUID_93hgISLe4EnNpwUAsi0RcPosqo_bA3Yn1lFem8W4_DafAMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/languages/label-groups/[labelGroupUUID].vue?macro=true";
import { default as label_45groupsvRNMfdTSNIGooVZnkTnK8UJdOgwvB2puHdMNch4RY7UMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/languages/label-groups.vue?macro=true";
import { default as indexjL6J7__96YjdlyD72t0LxmTx9lU6n1XRqMhPldFD_soMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/languages/[languageUUID]/labels/index.vue?macro=true";
import { default as _91labelUUID_93tBLkWIQNzCVgHX5ThEpf3gOFG78GE4nWYpPWvczke1EMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/languages/[languageUUID]/labels/[labelUUID].vue?macro=true";
import { default as create_45labelOzc5CATAYoC__MNxOQsxCeLnwNHSOLtIswu35JRr6YIMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/languages/[languageUUID]/labels/create-label.vue?macro=true";
import { default as labels1vZPp1lWSasy390jPBWbUsnEI4dPpjdtNPETYJSdU3EMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/languages/[languageUUID]/labels.vue?macro=true";
import { default as edit_45languagez2XKfmYLgE0cs7igIqmCTD38_FaMqz_1Kntpzt38YYYMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/languages/[languageUUID]/edit-language.vue?macro=true";
import { default as languages3dPhQKvE0duIY0Qz8rovp8fCDFWv8CVj66eOZeFBAMAMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/languages.vue?macro=true";
import { default as add_dbdAFDb_6SrPn7sXJs70y6DvHHasoFm1McmmVnu6fAMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dashboards/add.vue?macro=true";
import { default as indexM9YgrmdNXe1X5ETsXcqVRkFG_zd9W3AQTaZKSnTwrGsMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dashboards/index.vue?macro=true";
import { default as _91UUID_93nGcW0iYr_yknEWWiDF5Qi2Nl2ZcIbpcfHEJvQDKJ_eYMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dashboards/[UUID].vue?macro=true";
import { default as indexWG_s6JUH_d3Vq4fNr6vifNXxmxrtXnEhjet1hW6PBu4Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/dashboards/design/index.vue?macro=true";
import { default as indexYwCKIi_NANAXIhni3aBoZlEN9GSBAeKfaa5migegdQMMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dashboards/design/[UUID]/index.vue?macro=true";
import { default as mock_45databJ8zUcqdmJC6097HmsY4k9YD4Aii4wmgpatY_aLpC98Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/dashboards/design/[UUID]/mock-data.js?macro=true";
import { default as _91widgetUUID_93WhI_a9YBVA79QEsYBWvYhJtD_lYBMTSHxgX6BzSkq74Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/dashboards/design/[UUID]/[widgetUUID].vue?macro=true";
import { default as _91UUID_93p__RhI4ez1GKadC81tCchuHi7pH_k5T4eyiNtgC4bxoMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dashboards/design/[UUID].vue?macro=true";
import { default as designK1prh9ddmYQVNkd29UA5jeCfUhMFO4jQ6gmmlA_pPLEMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dashboards/design.vue?macro=true";
import { default as dashboardslDEPB_a_3GEZslUXIQoYqzN2RhKA7pnPoojN_AKsp1kMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/dashboards.vue?macro=true";
import { default as sql_45editorRxu0am78pwA3lMHFlC9V16s1f5R0Iv7rGvKvCp10eCYMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/sql-editor.vue?macro=true";
import { default as indexM6ZGK80LfaZ8GhXgHpzYjcQgmB3BI2UTi1cacfHQTXkMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/user-feeds/index.vue?macro=true";
import { default as _91UUID_93G_0wVo7Yso8ATsMqgPfryU2b0X4w60NBh3uauFfpOwMMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/user-feeds/[UUID].vue?macro=true";
import { default as add_45feedW4V4P5gqMh1JKt4qgrsc_po6JuHBaXAXXdMWye6AZ68Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/user-feeds/add-feed.vue?macro=true";
import { default as user_45feedshVon7abP56i_etIQ8vSeZgrqGflcJvSJKxfov6vU_X0Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/user-feeds.vue?macro=true";
import { default as indexZABBeRbWLkRwzCgvyor53GfWgS0hTnobjsNKqMrufCsMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/work-flows/index.vue?macro=true";
import { default as _91id_93NS10caOEUUoimKKuq3arjmvdbGyxNgfiRx_vX38vYuUMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/work-flows/design/[id].vue?macro=true";
import { default as _91_91id_93_93Mzd62VIvjAYZNkt4AuvWHGOcBZg0bvgrHoo4K_OP7bMMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/work-flows/manage/[[id]].vue?macro=true";
import { default as work_45flowsT26U_tdKAM35LKs9sBEdxtd6ilD_1k3T5_JfGcuwbh4Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/work-flows.vue?macro=true";
import { default as audit_45trail_6KAjDD4rNY6EIllKDyQnxjVBq6cY6P18Z6qfZXDXb4Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/audit-trail.vue?macro=true";
import { default as indexkufhZyS3_EWN6xvDwVhb29mkvA_d3xFg8iQVrvNu4mgMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/data-export/index.vue?macro=true";
import { default as data_45export50FUQFB1qVMF1nmJrRzM8ILYoI_BBwxbpLJlJaseJ0EMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/data-export.vue?macro=true";
import { default as indexhNPU4RmzkfvrWP6K2A2I_OAXit9qoOvaIN5GSXRAa68Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/data-models/index.vue?macro=true";
import { default as _91UUID_93upH9fe52QFAO9tbz0EB6QB_LgtVFDKeODXKGo8YANI8Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/data-models/[UUID].vue?macro=true";
import { default as add_45data_45modelDH9vlLT0FFZ5dJ7rDw8qKZUVJqZP36KY38CBo9SE8hQMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/data-models/add-data-model.vue?macro=true";
import { default as import_45data_45modelE7zo8rt_516xKKoe_kFc_5gqAcQdA1leIt7bOeNSzmQMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/data-models/import-data-model.vue?macro=true";
import { default as _91objectUUID_93Q364LFWZtdoO_25g2NWc5He2CUO6V5jSTEkRlzDtyGwMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/data-models/change-log/[objectUUID].vue?macro=true";
import { default as data_45modelsSJzApCbiZbhYZHf_EneAQFIn77hgdYCVPFfYIjSUyvUMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/data-models.vue?macro=true";
import { default as debug_45trace35oVgkPdZJmozHH4iMU3VaVNBLMICicdWSFjupbSsU0Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/debug-trace.vue?macro=true";
import { default as indexVdCTBqMyGeil3_hQ5EfDZlg_iLDtg_xxqcU1zjhSxJgMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/maintenance/index.vue?macro=true";
import { default as _91UUID_93_bcetGE5Wp7CwoChKFx_n7q1NFS9paj1lF8b_iGp_V4Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/maintenance/[UUID].vue?macro=true";
import { default as add_45screenJ0UvUT_UIZy69MX8aJNd6McHLdPR3749LDQGzAReffgMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/maintenance/add-screen.vue?macro=true";
import { default as maintenanceEGhLVkmHMPgUmNwjtz99x_TlKNEomfOFkZhBEhYwWmYMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/maintenance.vue?macro=true";
import { default as indexumck7h_ia6N6zmTVRONyJqUODwVB1livS4ZCkFfHGDMMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/action-flows/index.vue?macro=true";
import { default as addHenqdvGaCC524t4xeTiYfjnC9LJ78bdd0L_qAzMVtqsMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/action-flows/manage/add.vue?macro=true";
import { default as _91id_93c9IGpWtLW_eJ_4xIBt2jHkZJmm3paA6kGSHNAQir9XIMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/action-flows/design/[id].vue?macro=true";
import { default as _91id_93S_1wJBoQXMNT7c6LqZMldn2m1idDNe8dtooXzsfOHLgMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/action-flows/manage/[id].vue?macro=true";
import { default as indexgf29SXCTSuqNqRsiMEnBq1jkHXNa9thNqLNNpx6t860Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/action-flows/history/[id]/index.vue?macro=true";
import { default as _91historyUUID_93UW5Oy_mQ54h0lT6b_8lKKzMJY0EtSils8TpJy5dLCBQMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/action-flows/history/[id]/[historyUUID].vue?macro=true";
import { default as action_45flowsgk2hbhNe_q3w811aC6_JgAU58rQZA2TCsMjWAX665iEMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/action-flows.vue?macro=true";
import { default as addGdKBGWxVn2VxGjGm7mvboxk0cuGMFtBe48NfJ1UNRLAMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/applications/apps/add.vue?macro=true";
import { default as indexzI8asNZ7f9QeYyCiy_sLLk4Y6XaNvML0VRceJSUBbTUMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/applications/[tab]/index.vue?macro=true";
import { default as addj_7znvj_VCqp54ICfvvN4B4_RLsjoVk_ymZBZWvbEKUMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/applications/categories/add.vue?macro=true";
import { default as _91UUID_93qYdDXYHJGNXDspgYq0_piDRg92k7iPoUgBWm6MCF23sMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/applications/apps/manage/[UUID].vue?macro=true";
import { default as _91_91UUID_93_93JFSyhx_wBSPPQ0Wmd7KSQdJOOoJ4oup1ZgEuOKIPhuMMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/applications/menus/manage/[[UUID]].vue?macro=true";
import { default as add7kMmK7ERfhZw1LRIpYNq5tu_3nmhIcvJhFhtCaTTN_MMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/applications/solution-categories/add.vue?macro=true";
import { default as _91_91ID_93_93nj3oFs0k5HwNJuX57KOcmcIgErXPjnldnYNc7pb44eEMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/applications/categories/manage/[[ID]].vue?macro=true";
import { default as _91_91UUID_93_93UEbe7vcPyd_1qnSBGK8kqOFIJ2tdzWlqsm5J8lU6zjsMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/applications/solution-categories/manage/[[UUID]].vue?macro=true";
import { default as applicationsNJNuIQXqhkX2SvJ9U_PacHPjqm_dfsGvI6whneEsivYMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/applications.vue?macro=true";
import { default as addZWlh_TuwgcWSAnnLyGz1lYalEBBLPWrOsbNsMGzhnAAMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/add.vue?macro=true";
import { default as index2mGv_QweC3T6UfjEtC_X8Uk36OLLv7fpuhf_FPOYJrIMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/index.vue?macro=true";
import { default as kpis2iyHR3ulhd_KqCkB7Po1GGFp_erUTQuOzz_VsHzDDH4Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/kpis.vue?macro=true";
import { default as settingsGfEeCQWffAgZn9r4ns1Lu3KshEnWFbxrF2YOFYi3hM8Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/settings.vue?macro=true";
import { default as developerjNtNB3lei8RangaQG6lA97zBeFUpeZKjgmkKtGDzwRIMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/developer.vue?macro=true";
import { default as indexcVqu2H4795euw01T_o9qq6dxXpuOZ4RxPN9vnt3UfhwMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/rest-apis/index.vue?macro=true";
import { default as customize_45fields6_dcXkv_vrgPXgAbRegKl_g3aBiC7V_auRn6n6kOpiIMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/customize-fields.vue?macro=true";
import { default as indexeTZaGEDYs1LYT9NT7J7tPjio1oYzHutQ6tgnX8L_m14Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/rest-apis/[restUUID]/index.vue?macro=true";
import { default as rulesnW00YwocUe98E3z7GYrFj_LmvrIQoKXyQS_YTVJHJwIMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/rest-apis/[restUUID]/rules.vue?macro=true";
import { default as editEWbEr2LzOjwO4pjw5upURUijQ78Cgl8gifwTRGvzW1QMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit.vue?macro=true";
import { default as _91_91state_93_93hffj36oGcJqhGsrm_1chy_RxIFZ3DTRohkbCaLb467wMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/overview/[[state]].vue?macro=true";
import { default as overviewi6CVnEu4SKJhVOrpMPqab0zBcg4JxjPL2sK0hdByBpsMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/overview.vue?macro=true";
import { default as changelogXNBwGpN99OsBqHpgKYxLX5qwHneNaXb2TjTa1Bcsmi8Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/changelog.vue?macro=true";
import { default as whitelistingQMZiiwXvfLexGYxjw_9gVDzCTZWd9nuNty9Euu_h8I0Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/whitelisting.vue?macro=true";
import { default as notificationselX3yfQPVcvwTlT7mv_cSmD0nML29Lx77qUU2LGvG9kMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/notifications.vue?macro=true";
import { default as _91UUID_93x7XP0S_Q00Jn8oj5g6LCkbfXVPxJfOPuq0lz3v2PfS8Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID].vue?macro=true";
import { default as businessrulesU1MicEC0Bdgi68wOLQXiurZwaDOEVJvpg3joj6W_y7EMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/businessrules.vue?macro=true";
import { default as indexO_BcA4wZDZebjjKRmuXNbGQgeUhDUygObi6Ukgt66f8Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/external-apis/index.vue?macro=true";
import { default as external_45apisevZVpXVX2IdHXMs5iMib3oIWDEj_rdruiaaY5EB6kFYMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/external-apis.vue?macro=true";
import { default as _91_91notificationUUID_93_934rMJQSkWvbRc4b_N2IF5i9z_vOEHfvuqryZNf7sgE4wMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/notifications/[[UUID]]/[[notificationUUID]].vue?macro=true";
import { default as notificationsD_EJjGP_KOJ4Oau3FckBYnrjSMBlQJBbA8CJFPBN_osMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/notifications.vue?macro=true";
import { default as indexHni84_IeDFiUPsU_aUxdvRN1MTEjHoToGe1U9d2SSuEMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/package-market/index.vue?macro=true";
import { default as indexefeZf4m5vcmNHyoERnbrSHLSQ9j1aJJ7pM_chPcKaQUMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/package-market/[packageUUID]/index.vue?macro=true";
import { default as indexxVcVmYrp5lG4h_l4Zi1yLz_h4eoPo8HhIFqysIzCj_sMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/package-market/[packageUUID]/details/index.vue?macro=true";
import { default as _91releaseUUID_93_SLdAHw7kLzJS_bpLgBzhcJyLTfFqXErtiMysGTvxPEMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/package-market/[packageUUID]/details/[releaseUUID].vue?macro=true";
import { default as package_45marketMb_YFHU4t3tLZgqdzi_hr9r_L8RjEMrQQ2SwdljulG8Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/package-market.vue?macro=true";
import { default as indexddCZvkA2fhvbWFxm1LyGteWKWWxCM_MZbSyk1h_1xwMMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/task-templates/index.vue?macro=true";
import { default as _91UUID_9373Np0_V7RUDkWpPPSNQYhg49Zz7ftv6ndMnWKdByOR8Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/task-templates/[UUID].vue?macro=true";
import { default as add_45task_45templateH092__wVyt8baa3J9jYC7uBqpWmTks1S7qgGps6EnPwMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/task-templates/add-task-template.vue?macro=true";
import { default as task_45templatesl28O6K__nHxcz85Ir4IeZcScbcJvW6gHxOMq3BNE8XYMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/task-templates.vue?macro=true";
import { default as indexanyg1NE_EF_oRI4KcnGScBRWta3RzSNjBy6kXJaeLAwMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/endpoint-servers/index.vue?macro=true";
import { default as _91UUID_93pg_zAj1dG0poGE9A4MasaRpeWIpeRfY07ujDVXJC0S4Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/endpoint-servers/[UUID].vue?macro=true";
import { default as add_45serverbkPf390xrrsc7GiF1gKIpsVqDfjnXz_wOoYAsahUh50Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/endpoint-servers/add-server.vue?macro=true";
import { default as add_45file_45serverIPl1ciKjKiwx0k_Z8qZbj6luJYQEnu68tAZPN5cEg_wMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/endpoint-servers/add-file-server.vue?macro=true";
import { default as endpoint_45serverszcry6DMzWCOdKbgHgCfKC_BwLbrtsSmIMl_P_161RcEMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/endpoint-servers.vue?macro=true";
import { default as indexJCmyzabKbErBUCJdgBD6VtUQduhvuHQS8YaC9175_XsMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/system-variables/index.vue?macro=true";
import { default as system_45variablesN__bNVN72neG8wsstoNhVNcSfsWYpRttEwH4uL5K6_0Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/system-variables.vue?macro=true";
import { default as indexB7RRmvM8bTWsHIfHbv_zjIOLE5VoBaNUxzW94SvF_PQMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/force-logout/index.vue?macro=true";
import { default as indexfiLSwYzlieA6qkk2iKQnSBQalbhIbtCXX99gwqeyzkEMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/snapshots-progress/index.vue?macro=true";
import { default as snapshots_45progress5tvlyTOyWQ_cQw8fLVEO83zgKEdcQezf43VPJvLy_XsMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/snapshots-progress.vue?macro=true";
import { default as indexcdMTnRYrCt1OHzWM1lLoD9vm9WEoYrrzuSJzAloxvAEMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/email-configuration/index.vue?macro=true";
import { default as email_45configurationXVyOz0VpNFmLXki2jPr9KILGUEDWkSj7wrRfKflcTUIMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/email-configuration.vue?macro=true";
import { default as indexiTbpCfJwx9fJZJln4whb5WCGG0NX7hBoynMpLlJ73yEMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/user-authorizations/[tab]/index.vue?macro=true";
import { default as add_45userAf0bEQd2IZf7hZWfzmxUQVAIAnHVy4txmrGLh6FagvAMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/user-authorizations/users/add-user.vue?macro=true";
import { default as import_45userjmJu3yJtu5Pq0ZYHAlriy3IVIDs72VtuWoxOUpF7HcUMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/user-authorizations/users/import-user.vue?macro=true";
import { default as _91id_937WVgdYimAAH5G23D9TCUFWX3Ntlc__xerR7LG6hzozIMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/user-authorizations/users/manage/[id].vue?macro=true";
import { default as _91id_93L0fbThMhYw_k5vZPP6JVW8lvrL5gaJ3nOTW_ISYg_4EMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/user-authorizations/users/change-logs/[id].vue?macro=true";
import { default as user_45authorizationsSblA1eaRfhoHk8F1JYthnmryH24Hg_9tuT6GOMoBzxwMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/user-authorizations.vue?macro=true";
import { default as application_45insightsAcI8LIYADYuuvqarFCtJTZ0g1Jxbx0_RhG_j8zMNbNIMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/application-insights.vue?macro=true";
import { default as index6aaf_ZtMhIn7JsGwASOzQ9nLQwy33A0N_0nZ7rcFWHEMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/application-packages/index.vue?macro=true";
import { default as managenTOBQpicPpJ_eHe_KQJ9yEfNUWuh6YQ0EAH5tcb9BM0Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/application-packages/[uuid]/manage.vue?macro=true";
import { default as indexJNaLflm4Tgw_qtTZtHY19x0Now1_fhn_pg3pTTVRrLgMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/application-packages/[uuid]/[tab]/index.vue?macro=true";
import { default as _91action_93u8zh5PiXKqUs_TYwSRVRJdzoz81P0Ya_GS_NdyoHcJUMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/application-packages/[uuid]/[tab]/[action].vue?macro=true";
import { default as _91uuid_93mCI62iKMIOGMBbsqFodgenEbb6qfwak3M4CplhcZnNIMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/application-packages/[uuid].vue?macro=true";
import { default as add_45application_45packageuI48JSoQGkFExMOdHwFt8N6VQAWGzOFvFgqeXf8nm5kMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/application-packages/add-application-package.vue?macro=true";
import { default as application_45packageslqEqz_c0OJAOMj1WhKWmsa6Fmx4MV_rINL38d_07_LYMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/application-packages.vue?macro=true";
import { default as scim_45ip_45whitelistingOCkK70Oqs4Lu_zhu5LpvRUWYR44TkExvr8VbQzqWrWsMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/scim-ip-whitelisting.vue?macro=true";
import { default as indexKr6nWQfkf4XqqWRzNqLOUfWh8iUWFaPLPJjolCv8SO4Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/notification-template/index.vue?macro=true";
import { default as _91UUID_93ukmYj_zxZOrYX11PbemjWDhw2_8KzO2WE60d1mCWj5YMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/notification-template/[UUID].vue?macro=true";
import { default as add_45templatebnX21WW_Ubgpc500mjGbLjiOqBhqkpX0r_aDZ5ggJB0Meta } from "/azp/agent/_work/11/s/frontend/pages/admin/notification-template/add-template.vue?macro=true";
import { default as notification_45templatee70iHKoO8mdhwdZgt4kwrs_2RiOmwTwH0v9BOc8ZGuMMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/notification-template.vue?macro=true";
import { default as indexuzn4rHQE9f_lRmo074lRzwkv6hKNKfBg0sBTX_UeCUgMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/workflow-trigger-log/index.vue?macro=true";
import { default as indexqNaq3Za9XN9gM9zOuZTHtVIJyXdFr6zo2_HS9PVpn4wMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/container-applications/index.vue?macro=true";
import { default as data_45export_45endpoint_45serverslQFhT_Xq0T9awA9Tt4hpolzU52_bcg7kR9wxBo_YepEMeta } from "/azp/agent/_work/11/s/frontend/pages/admin/data-export-endpoint-servers.vue?macro=true";
import { default as adminX1_0a14eQY6jMsVzq2bX6zW7hNZKxq_jLuIAGSeayrYMeta } from "/azp/agent/_work/11/s/frontend/pages/admin.vue?macro=true";
import { default as indexg1Cp4TzEmn2iJTlbLu1M1qoonL0vLJpzifT6gIr4T9cMeta } from "/azp/agent/_work/11/s/frontend/pages/index.vue?macro=true";
import { default as loginLK8XeIG20n_5_dFWbuqLvmfwaVlpbGfL_rRVIwbkY8YMeta } from "/azp/agent/_work/11/s/frontend/pages/login.vue?macro=true";
import { default as myYJAzGDvcbwc4bskuKxfVwY9aeB3E0T0f78XzuRCxG2IMeta } from "/azp/agent/_work/11/s/frontend/pages/tasks/my.vue?macro=true";
import { default as indexV_jxMDMaXotfIzZJbh4v_SoKmw_pZQeknkl2oRpaRQQMeta } from "/azp/agent/_work/11/s/frontend/pages/tasks/history/index.vue?macro=true";
import { default as history975aIGhaO80JoTc1VwG_2bqakEGsWBdTYoBI3y94FAsMeta } from "/azp/agent/_work/11/s/frontend/pages/tasks/history.vue?macro=true";
import { default as tasksjqFH0H9SzHQIFKell_Ab3lyRDF_tnXLYxSFR2Gd8qNUMeta } from "/azp/agent/_work/11/s/frontend/pages/tasks.vue?macro=true";
import { default as logout2xzEm2N9FcSy1K1_RamLoJLymS_56CLALYUm1KTiebQMeta } from "/azp/agent/_work/11/s/frontend/pages/logout.vue?macro=true";
import { default as _91_46_46_46slug_93qEqLz8835HjOo3noVwGeiQCdGG7esNFqcMyD1ry4drgMeta } from "/azp/agent/_work/11/s/frontend/pages/[...slug].vue?macro=true";
import { default as launchpadiUNxPece5_VKKuTxux6aySsqzSuEIVLdVC0t37D5ZvIMeta } from "/azp/agent/_work/11/s/frontend/pages/launchpad.vue?macro=true";
import { default as verify_45otpNtHsB53goHQgmsNclcTK8ZbLHfxeJ8ibSWKUywFALV8Meta } from "/azp/agent/_work/11/s/frontend/pages/verify-otp.vue?macro=true";
import { default as maintenanceozR1FB_3KCde8v17Q9n3cpN8w1ihyNnBpWCy6ZUjIPoMeta } from "/azp/agent/_work/11/s/frontend/pages/maintenance.vue?macro=true";
import { default as _91_91mode_93_93WqLNY3i6A5bGxigeSlkXfzWXu795T9_hZxh5QeoY8QgMeta } from "/azp/agent/_work/11/s/frontend/pages/wizard/[url]/[recordUUID]/[[phase]]/[[step]]/[[mode]].vue?macro=true";
import { default as _91recordUUID_93GWRLQ9yZqmfI7H5_IBOVVu9BnNmYQqZfIc_Ut76hADgMeta } from "/azp/agent/_work/11/s/frontend/pages/wizard/[url]/[recordUUID].vue?macro=true";
import { default as _91url_93G6_p1OaUN5xAJjxq03J3m11PoeI5ZsGlRmVc1iD8f_8Meta } from "/azp/agent/_work/11/s/frontend/pages/wizard/[url].vue?macro=true";
import { default as not_45authorized_ElAO8ZCsbO3N8BW6wxNTfy5axPY0ZsDqzCxpRjsr2IMeta } from "/azp/agent/_work/11/s/frontend/pages/not-authorized.vue?macro=true";
import { default as reset_45passwordfbmidRnbmFuEb05enknQfKmCBtszx97g1uer7R4TljcMeta } from "/azp/agent/_work/11/s/frontend/pages/reset-password.vue?macro=true";
import { default as forgot_45password4lk0QOH91GqzrsC5_ttOimucZQuun5WsvxJXApTRxLAMeta } from "/azp/agent/_work/11/s/frontend/pages/forgot-password.vue?macro=true";
import { default as indexucSf6HzXj9cxY1RI5U8Vt3JeFFBEyry0InrkL4Em_2AMeta } from "/azp/agent/_work/11/s/frontend/pages/form/[url]/index.vue?macro=true";
import { default as _91UUID_93OogU_xIWrUx1XV16W5NDpGYU67cpAz_8rVklN_FL3WEMeta } from "/azp/agent/_work/11/s/frontend/pages/widgets/analyze/[UUID].vue?macro=true";
import { default as index4eVu9AEwjDWJ6NcJxbfCahholk_bQdT33059vpWgiPEMeta } from "/azp/agent/_work/11/s/frontend/pages/form/[url]/[tenantEntryUUID]/index.vue?macro=true";
import { default as _91recordUUID_93XOjmM8t_CKBtNz9lpiCbNPf402_fv2JuIQ7eUvNnnDgMeta } from "/azp/agent/_work/11/s/frontend/pages/form/[url]/[tenantEntryUUID]/[recordUUID].vue?macro=true";
import { default as _91tenantEntryUUID_93mIAIPMXNuKNMzAC3Z0fD5pgfTFIDwldKZM0I867sVYEMeta } from "/azp/agent/_work/11/s/frontend/pages/form/[url]/[tenantEntryUUID].vue?macro=true";
export default [
  {
    name: userUNv7JsFNXFLhP__rvGsQ8E0KYfA5o_a6unklnNMwxbgMeta?.name,
    path: "/user",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/user.vue"),
    children: [
  {
    name: "user",
    path: "",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/user/index.vue")
  },
  {
    name: "user-downloads",
    path: "downloads",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/user/downloads/index.vue")
  },
  {
    name: "user-delegate-account",
    path: "delegate-account",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/user/delegate-account.vue")
  },
  {
    name: "user-account-details",
    path: "account-details",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/user/account-details/index.vue")
  },
  {
    name: "user-change-password",
    path: "change-password",
    meta: index_RS3m0CnYSVGLKbqYlWI2zKjL_AOCP7DRzUJ1dQQJt4Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/user/change-password/index.vue")
  },
  {
    name: "user-platform-notifications",
    path: "platform-notifications",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/user/platform-notifications/index.vue")
  }
]
  },
  {
    name: adminX1_0a14eQY6jMsVzq2bX6zW7hNZKxq_jLuIAGSeayrYMeta?.name,
    path: "/admin",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin.vue"),
    children: [
  {
    name: jobs8OH23zClk5LNjLsSFWgFt4Est9SPoEFb0jt6SIFiPNQMeta?.name,
    path: "jobs",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/jobs.vue"),
    children: [
  {
    name: "admin-jobs-add",
    path: "add",
    meta: addIxbHY5AC_ApqqDQT4aOzSiwchfQrGERp_c4Ue6_hMKYMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/jobs/add.vue")
  },
  {
    name: "admin-jobs",
    path: "",
    meta: indexPpCqib3t0X7xMIyVAvFOobz6uEO_NaUjw_tgEeTedXgMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/jobs/index.vue")
  },
  {
    name: "admin-jobs-UUID",
    path: ":UUID()",
    meta: _91UUID_93bqVdspIlJC0rRLmUdR5w42VDxIetzRF9FDBLmedCmPQMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/jobs/[UUID].vue")
  },
  {
    name: "admin-jobs-history-id",
    path: "history/:id?",
    meta: _91_91id_93_93ebR01cbqmLH1OQ6UnRAB5DhrmRu9kjwVeXbcheGXhCIMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/jobs/history/[[id]].vue")
  }
]
  },
  {
    name: "admin",
    path: "",
    meta: indexSOrjF4ZT_spBvklYHc5XPsXRBABNzJUZlZa81TihWF4Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/index.vue")
  },
  {
    name: rolesl_m5VwPATCiO1xi7hdDJIIcqcRjocq8lGLqQobiFXs0Meta?.name,
    path: "roles",
    meta: rolesl_m5VwPATCiO1xi7hdDJIIcqcRjocq8lGLqQobiFXs0Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/roles.vue"),
    children: [
  {
    name: "admin-roles-add",
    path: "add",
    meta: addNFI8kpkPNE1_enrlNA72m8h01IKFsDGB3uteAxFbZ5oMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/roles/add.vue")
  },
  {
    name: "admin-roles-ID",
    path: ":ID()",
    meta: _91ID_93h_VdHilkXSPOU6QrUVPSKyevctCcOwjCxLo8Q8tFSXYMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/roles/[ID].vue")
  },
  {
    name: "admin-roles",
    path: "",
    meta: index2MDumYFhfM0lD0BDyH8Yp8lAF_nyE8cNF2PGgsRRItgMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/roles/index.vue")
  },
  {
    name: "admin-roles-authorizations-add",
    path: "authorizations/add",
    meta: add_BC_EUI_gvumiaOZta4rVje1DIpUnd5lDxiK0UV_UG0Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/roles/authorizations/add.vue")
  },
  {
    name: "admin-roles-authorizations-ID",
    path: "authorizations/:ID()",
    meta: _91ID_933_g3GWC9xmxZ0aitVDZkDAcydm1LTeldilKghgpDlGMMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/roles/authorizations/[ID].vue")
  }
]
  },
  {
    name: "admin-entity",
    path: "entity",
    meta: entity9ijf22X4N7IFPlIAOOleVdIqndaEIc4vKt1RTIe157kMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/entity.vue"),
    children: [
  {
    name: "admin-entity-tab",
    path: ":tab()",
    meta: indexXktINc99pDsdhOBk4d9AX7YyHP8B3ppnug6POZJn__wMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/entity/[tab]/index.vue")
  }
]
  },
  {
    name: datasetowZBtxpWvtzPIAqOSKhnb7JHqXfAUEjpYIOYPycr6Y8Meta?.name,
    path: "dataset",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dataset.vue"),
    children: [
  {
    name: "admin-dataset-add",
    path: "add",
    meta: addT3aou_5yMcS8VySxSwZ_ZiR0yaFLQluPXfRuMOwhhEUMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dataset/add.vue")
  },
  {
    name: "admin-dataset",
    path: "",
    meta: index6iXaX3mCqQt_d9WtYSJoklROjUjCg_v9yAy4gSHB5tcMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dataset/index.vue")
  },
  {
    name: "admin-dataset-edit-UUID",
    path: "edit/:UUID()",
    meta: _91UUID_93p1RewijEVVRPwNc44SorkrEWyuRJNZyrrxKewAyamZAMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dataset/edit/[UUID].vue")
  },
  {
    name: "admin-dataset-details-UUID-name",
    path: "details/:UUID()/:name()",
    meta: _91name_93TW3wjt4ExCfkU2WhZiPAWDNQb2U1maUSPWxgtvr5IIEMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dataset/details/[UUID]/[name].vue")
  },
  {
    name: "admin-dataset-credentials-UUID-add",
    path: "credentials/:UUID()/add",
    meta: addJB6NeEvtcOZwdZk5KwcMvj7kBtJsEkPO509Y0mI0z7cMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dataset/credentials/[UUID]/add.vue")
  },
  {
    name: "admin-dataset-credentials-UUID",
    path: "credentials/:UUID()",
    meta: indexk2h4fqlK9kNO8JtC_7wmZA_wLIIB4UkoGUduun6P1akMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dataset/credentials/[UUID]/index.vue")
  },
  {
    name: "admin-dataset-manage-UUID-name",
    path: "manage/:UUID?/:name?",
    meta: _91_91name_93_93tLVhOesy6ASU0FQdJarXCFcULOgKerrIiu45xlVvr88Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dataset/manage/[[UUID]]/[[name]].vue")
  },
  {
    name: "admin-dataset-credentials-UUID-credentialUUID",
    path: "credentials/:UUID()/:credentialUUID()",
    meta: _91credentialUUID_93DloCdfR9wNcG5mUTSdnWjwXL_UiWIVCZKFKustxS28YMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dataset/credentials/[UUID]/[credentialUUID].vue")
  }
]
  },
  {
    name: objectsXGIjGPOeTuZQaLISg1AbdgI_DWfHSb_AqBqHvpyvIXUMeta?.name,
    path: "objects",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/objects.vue"),
    children: [
  {
    name: "admin-objects",
    path: "",
    meta: indexyYOIn4U4YuAXScW7on6IOv4IzIFyspgmQb5_ItfjSFgMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/objects/index.vue")
  },
  {
    name: "admin-objects-overview-UUID",
    path: "overview/:UUID()",
    meta: _91UUID_93BbtPTDf4_kZ9I2ZRsSSKzqaydhHJBYrz6RhnA3crDBwMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/objects/overview/[UUID].vue")
  },
  {
    name: "admin-objects-objectUUID-records",
    path: ":objectUUID()/records",
    meta: recordsG80J9Ny2HXF48ylVuykOmAGT4SqtDY__cS3Vgb0HJjIMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/records.vue"),
    children: [
  {
    name: "admin-objects-objectUUID-records-add",
    path: "add",
    meta: addqcgp2cYAnakvOREJJgUNMgZyFLyJ_CuSbxUfG1AvhUsMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/records/add.vue")
  },
  {
    name: "admin-objects-objectUUID-records-recordUUID",
    path: ":recordUUID?",
    meta: _91_91recordUUID_93_934otNmFykkWkegrwkb11cMIDPoPkeNbhmhoqdPzZualcMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/records/[[recordUUID]].vue")
  }
]
  },
  {
    name: "admin-objects-objectUUID-templates",
    path: ":objectUUID()/templates",
    meta: templatesFPwqm7Ft6YWnA8N3ED2f9o17dfXytTl_14wvh_f6j4QMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/templates.vue"),
    children: [
  {
    name: "admin-objects-objectUUID-templates-templateUUID",
    path: ":templateUUID?",
    meta: _91_91templateUUID_93_935dTSxmyomjAmYIvPk7ugij1rOf5EBaGiy15N1jy4wv0Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/templates/[[templateUUID]].vue")
  }
]
  },
  {
    name: "admin-objects-objectUUID-display",
    path: ":objectUUID()/display",
    meta: indexHbsdpSLqiIORpg2daWTW7CKYQBHwTx4sQd9j5AIHNyoMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/display/index.vue")
  },
  {
    name: "admin-objects-objectUUID-display-recordUUID",
    path: ":objectUUID()/display/:recordUUID()",
    meta: _91recordUUID_93sxvL_gNSn67KqTnf3qRFhPMiiJo_9DF9GUKl227YKKAMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/display/[recordUUID].vue"),
    children: [
  {
    name: "admin-objects-objectUUID-display-recordUUID-tab",
    path: ":tab?",
    meta: _91_91tab_93_93SkJFqRiu0mJEnJB1ZX8q5xvMkHr6Z7lh1w1Xm_q_TZcMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/display/[recordUUID]/[[tab]].vue")
  }
]
  },
  {
    name: "admin-objects-objectUUID-rest-api-keys-UUID",
    path: ":objectUUID()/rest-api-keys/:UUID?",
    meta: indexs5XRbkWnoROWeEGjTC_IECLPhh8uW_PtQ5ajXH7b640Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/rest-api-keys/[[UUID]]/index.vue")
  },
  {
    name: "admin-objects-objectUUID-rest-api-keys-UUID-rules",
    path: ":objectUUID()/rest-api-keys/:UUID?/rules",
    meta: rulesklF2zNOo01qLte59l8sBDuV8gftJVPX4MaOwOtwTSIsMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/objects/[objectUUID]/rest-api-keys/[[UUID]]/rules.vue")
  }
]
  },
  {
    name: wizardsjNpKYZD5P_l6Fb5YPuxXwJmMfgv0k4jISZE1cZJsHPcMeta?.name,
    path: "wizards",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/wizards.vue"),
    children: [
  {
    name: "admin-wizards",
    path: "",
    meta: indexObxFgEaSN2BTuNkENs1Todd5qjveMdpRPGMHSP5iWUkMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/wizards/index.vue")
  },
  {
    name: "admin-wizards-UUID",
    path: ":UUID()",
    meta: _91UUID_93t2yIhIQhqIAEaR8hp_cUyWCksPDWAkDdN_R5TpcVrzsMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/wizards/[UUID].vue")
  },
  {
    name: "admin-wizards-add-wizard",
    path: "add-wizard",
    meta: add_45wizardF_k8ewfF2z2aemU6p2Xg6gXbr2si6q3_WjD2gwzlAscMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/wizards/add-wizard.vue")
  },
  {
    name: "admin-wizards-manage-UUID",
    path: "manage/:UUID()",
    meta: _91UUID_936IcCuyZ_kxUoST4e8M85PTbaHzX7OMSSRMI3OHob9NoMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/wizards/manage/[UUID].vue")
  }
]
  },
  {
    name: cron_45jobsJ1WK8qScqkYKs8R49YxdjnbaBTlZVKqN4SNcDOyWIK8Meta?.name,
    path: "cron-jobs",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/cron-jobs.vue"),
    children: [
  {
    name: "admin-cron-jobs",
    path: "",
    meta: index_NxpBfgpPgJllB_Au7DxIGaaOVO8qPTTXa65ZXyJEvcMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/cron-jobs/index.vue")
  },
  {
    name: "admin-cron-jobs-name",
    path: ":name()",
    meta: _91name_93MOG0lcrQMt6f8he2PJ0g7_SiLCFK_xiBSAIBBMXk_voMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/cron-jobs/[name].vue")
  }
]
  },
  {
    name: languages3dPhQKvE0duIY0Qz8rovp8fCDFWv8CVj66eOZeFBAMAMeta?.name,
    path: "languages",
    meta: languages3dPhQKvE0duIY0Qz8rovp8fCDFWv8CVj66eOZeFBAMAMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/languages.vue"),
    children: [
  {
    name: "admin-languages-add",
    path: "add",
    meta: addw7GMH_sNatwm_3kjbdjc57cTr7ehnRwh_LN6tnR4DNsMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/languages/add.vue")
  },
  {
    name: "admin-languages",
    path: "",
    meta: indexfwmr7U_V67fG2i6nMBJhIkIsfrCmu9Qh1T1VsyPtT0wMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/languages/index.vue")
  },
  {
    name: label_45groupsvRNMfdTSNIGooVZnkTnK8UJdOgwvB2puHdMNch4RY7UMeta?.name,
    path: "label-groups",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/languages/label-groups.vue"),
    children: [
  {
    name: "admin-languages-label-groups-add",
    path: "add",
    meta: addNBYM7UFmo8qtxtJfpvKzKneR9O_TzvYQ4BZqe8ST1KYMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/languages/label-groups/add.vue")
  },
  {
    name: "admin-languages-label-groups",
    path: "",
    meta: indexOc3DWdtQBWwZaJIGB5IcDUESFFolW9jXcvwO8uUCoScMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/languages/label-groups/index.vue")
  },
  {
    name: "admin-languages-label-groups-labelGroupUUID",
    path: ":labelGroupUUID()",
    meta: _91labelGroupUUID_93hgISLe4EnNpwUAsi0RcPosqo_bA3Yn1lFem8W4_DafAMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/languages/label-groups/[labelGroupUUID].vue")
  }
]
  },
  {
    name: labels1vZPp1lWSasy390jPBWbUsnEI4dPpjdtNPETYJSdU3EMeta?.name,
    path: ":languageUUID()/labels",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/languages/[languageUUID]/labels.vue"),
    children: [
  {
    name: "admin-languages-languageUUID-labels",
    path: "",
    meta: indexjL6J7__96YjdlyD72t0LxmTx9lU6n1XRqMhPldFD_soMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/languages/[languageUUID]/labels/index.vue")
  },
  {
    name: "admin-languages-languageUUID-labels-labelUUID",
    path: ":labelUUID()",
    meta: _91labelUUID_93tBLkWIQNzCVgHX5ThEpf3gOFG78GE4nWYpPWvczke1EMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/languages/[languageUUID]/labels/[labelUUID].vue")
  },
  {
    name: "admin-languages-languageUUID-labels-create-label",
    path: "create-label",
    meta: create_45labelOzc5CATAYoC__MNxOQsxCeLnwNHSOLtIswu35JRr6YIMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/languages/[languageUUID]/labels/create-label.vue")
  }
]
  },
  {
    name: "admin-languages-languageUUID-edit-language",
    path: ":languageUUID()/edit-language",
    meta: edit_45languagez2XKfmYLgE0cs7igIqmCTD38_FaMqz_1Kntpzt38YYYMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/languages/[languageUUID]/edit-language.vue")
  }
]
  },
  {
    name: dashboardslDEPB_a_3GEZslUXIQoYqzN2RhKA7pnPoojN_AKsp1kMeta?.name,
    path: "dashboards",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dashboards.vue"),
    children: [
  {
    name: "admin-dashboards-add",
    path: "add",
    meta: add_dbdAFDb_6SrPn7sXJs70y6DvHHasoFm1McmmVnu6fAMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dashboards/add.vue")
  },
  {
    name: "admin-dashboards",
    path: "",
    meta: indexM9YgrmdNXe1X5ETsXcqVRkFG_zd9W3AQTaZKSnTwrGsMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dashboards/index.vue")
  },
  {
    name: "admin-dashboards-UUID",
    path: ":UUID()",
    meta: _91UUID_93nGcW0iYr_yknEWWiDF5Qi2Nl2ZcIbpcfHEJvQDKJ_eYMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dashboards/[UUID].vue")
  },
  {
    name: designK1prh9ddmYQVNkd29UA5jeCfUhMFO4jQ6gmmlA_pPLEMeta?.name,
    path: "design",
    meta: designK1prh9ddmYQVNkd29UA5jeCfUhMFO4jQ6gmmlA_pPLEMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dashboards/design.vue"),
    children: [
  {
    name: "admin-dashboards-design",
    path: "",
    meta: indexWG_s6JUH_d3Vq4fNr6vifNXxmxrtXnEhjet1hW6PBu4Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dashboards/design/index.vue")
  },
  {
    name: _91UUID_93p__RhI4ez1GKadC81tCchuHi7pH_k5T4eyiNtgC4bxoMeta?.name,
    path: ":UUID()",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dashboards/design/[UUID].vue"),
    children: [
  {
    name: "admin-dashboards-design-UUID",
    path: "",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dashboards/design/[UUID]/index.vue")
  },
  {
    name: "admin-dashboards-design-UUID-mock-data",
    path: "mock-data",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dashboards/design/[UUID]/mock-data.js")
  },
  {
    name: "admin-dashboards-design-UUID-widgetUUID",
    path: ":widgetUUID()",
    meta: _91widgetUUID_93WhI_a9YBVA79QEsYBWvYhJtD_lYBMTSHxgX6BzSkq74Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/dashboards/design/[UUID]/[widgetUUID].vue")
  }
]
  }
]
  }
]
  },
  {
    name: "admin-sql-editor",
    path: "sql-editor",
    meta: sql_45editorRxu0am78pwA3lMHFlC9V16s1f5R0Iv7rGvKvCp10eCYMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/sql-editor.vue")
  },
  {
    name: user_45feedshVon7abP56i_etIQ8vSeZgrqGflcJvSJKxfov6vU_X0Meta?.name,
    path: "user-feeds",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/user-feeds.vue"),
    children: [
  {
    name: "admin-user-feeds",
    path: "",
    meta: indexM6ZGK80LfaZ8GhXgHpzYjcQgmB3BI2UTi1cacfHQTXkMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/user-feeds/index.vue")
  },
  {
    name: "admin-user-feeds-UUID",
    path: ":UUID()",
    meta: _91UUID_93G_0wVo7Yso8ATsMqgPfryU2b0X4w60NBh3uauFfpOwMMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/user-feeds/[UUID].vue")
  },
  {
    name: "admin-user-feeds-add-feed",
    path: "add-feed",
    meta: add_45feedW4V4P5gqMh1JKt4qgrsc_po6JuHBaXAXXdMWye6AZ68Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/user-feeds/add-feed.vue")
  }
]
  },
  {
    name: work_45flowsT26U_tdKAM35LKs9sBEdxtd6ilD_1k3T5_JfGcuwbh4Meta?.name,
    path: "work-flows",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/work-flows.vue"),
    children: [
  {
    name: "admin-work-flows",
    path: "",
    meta: indexZABBeRbWLkRwzCgvyor53GfWgS0hTnobjsNKqMrufCsMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/work-flows/index.vue")
  },
  {
    name: "admin-work-flows-design-id",
    path: "design/:id()",
    meta: _91id_93NS10caOEUUoimKKuq3arjmvdbGyxNgfiRx_vX38vYuUMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/work-flows/design/[id].vue")
  },
  {
    name: "admin-work-flows-manage-id",
    path: "manage/:id?",
    meta: _91_91id_93_93Mzd62VIvjAYZNkt4AuvWHGOcBZg0bvgrHoo4K_OP7bMMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/work-flows/manage/[[id]].vue")
  }
]
  },
  {
    name: "admin-audit-trail",
    path: "audit-trail",
    meta: audit_45trail_6KAjDD4rNY6EIllKDyQnxjVBq6cY6P18Z6qfZXDXb4Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/audit-trail.vue")
  },
  {
    name: data_45export50FUQFB1qVMF1nmJrRzM8ILYoI_BBwxbpLJlJaseJ0EMeta?.name,
    path: "data-export",
    meta: data_45export50FUQFB1qVMF1nmJrRzM8ILYoI_BBwxbpLJlJaseJ0EMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/data-export.vue"),
    children: [
  {
    name: "admin-data-export",
    path: "",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/data-export/index.vue")
  }
]
  },
  {
    name: data_45modelsSJzApCbiZbhYZHf_EneAQFIn77hgdYCVPFfYIjSUyvUMeta?.name,
    path: "data-models",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/data-models.vue"),
    children: [
  {
    name: "admin-data-models",
    path: "",
    meta: indexhNPU4RmzkfvrWP6K2A2I_OAXit9qoOvaIN5GSXRAa68Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/data-models/index.vue")
  },
  {
    name: "admin-data-models-UUID",
    path: ":UUID()",
    meta: _91UUID_93upH9fe52QFAO9tbz0EB6QB_LgtVFDKeODXKGo8YANI8Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/data-models/[UUID].vue")
  },
  {
    name: "admin-data-models-add-data-model",
    path: "add-data-model",
    meta: add_45data_45modelDH9vlLT0FFZ5dJ7rDw8qKZUVJqZP36KY38CBo9SE8hQMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/data-models/add-data-model.vue")
  },
  {
    name: "admin-data-models-import-data-model",
    path: "import-data-model",
    meta: import_45data_45modelE7zo8rt_516xKKoe_kFc_5gqAcQdA1leIt7bOeNSzmQMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/data-models/import-data-model.vue")
  },
  {
    name: "admin-data-models-change-log-objectUUID",
    path: "change-log/:objectUUID()",
    meta: _91objectUUID_93Q364LFWZtdoO_25g2NWc5He2CUO6V5jSTEkRlzDtyGwMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/data-models/change-log/[objectUUID].vue")
  }
]
  },
  {
    name: "admin-debug-trace",
    path: "debug-trace",
    meta: debug_45trace35oVgkPdZJmozHH4iMU3VaVNBLMICicdWSFjupbSsU0Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/debug-trace.vue")
  },
  {
    name: maintenanceEGhLVkmHMPgUmNwjtz99x_TlKNEomfOFkZhBEhYwWmYMeta?.name,
    path: "maintenance",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/maintenance.vue"),
    children: [
  {
    name: "admin-maintenance",
    path: "",
    meta: indexVdCTBqMyGeil3_hQ5EfDZlg_iLDtg_xxqcU1zjhSxJgMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/maintenance/index.vue")
  },
  {
    name: "admin-maintenance-UUID",
    path: ":UUID()",
    meta: _91UUID_93_bcetGE5Wp7CwoChKFx_n7q1NFS9paj1lF8b_iGp_V4Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/maintenance/[UUID].vue")
  },
  {
    name: "admin-maintenance-add-screen",
    path: "add-screen",
    meta: add_45screenJ0UvUT_UIZy69MX8aJNd6McHLdPR3749LDQGzAReffgMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/maintenance/add-screen.vue")
  }
]
  },
  {
    name: action_45flowsgk2hbhNe_q3w811aC6_JgAU58rQZA2TCsMjWAX665iEMeta?.name,
    path: "action-flows",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/action-flows.vue"),
    children: [
  {
    name: "admin-action-flows",
    path: "",
    meta: indexumck7h_ia6N6zmTVRONyJqUODwVB1livS4ZCkFfHGDMMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/action-flows/index.vue")
  },
  {
    name: "admin-action-flows-manage-add",
    path: "manage/add",
    meta: addHenqdvGaCC524t4xeTiYfjnC9LJ78bdd0L_qAzMVtqsMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/action-flows/manage/add.vue")
  },
  {
    name: "admin-action-flows-design-id",
    path: "design/:id()",
    meta: _91id_93c9IGpWtLW_eJ_4xIBt2jHkZJmm3paA6kGSHNAQir9XIMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/action-flows/design/[id].vue")
  },
  {
    name: "admin-action-flows-manage-id",
    path: "manage/:id()",
    meta: _91id_93S_1wJBoQXMNT7c6LqZMldn2m1idDNe8dtooXzsfOHLgMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/action-flows/manage/[id].vue")
  },
  {
    name: "admin-action-flows-history-id",
    path: "history/:id()",
    meta: indexgf29SXCTSuqNqRsiMEnBq1jkHXNa9thNqLNNpx6t860Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/action-flows/history/[id]/index.vue")
  },
  {
    name: "admin-action-flows-history-id-historyUUID",
    path: "history/:id()/:historyUUID()",
    meta: _91historyUUID_93UW5Oy_mQ54h0lT6b_8lKKzMJY0EtSils8TpJy5dLCBQMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/action-flows/history/[id]/[historyUUID].vue")
  }
]
  },
  {
    name: "admin-applications",
    path: "applications",
    meta: applicationsNJNuIQXqhkX2SvJ9U_PacHPjqm_dfsGvI6whneEsivYMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/applications.vue"),
    children: [
  {
    name: "admin-applications-apps-add",
    path: "apps/add",
    meta: addGdKBGWxVn2VxGjGm7mvboxk0cuGMFtBe48NfJ1UNRLAMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/applications/apps/add.vue")
  },
  {
    name: "admin-applications-tab",
    path: ":tab()",
    meta: indexzI8asNZ7f9QeYyCiy_sLLk4Y6XaNvML0VRceJSUBbTUMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/applications/[tab]/index.vue")
  },
  {
    name: "admin-applications-categories-add",
    path: "categories/add",
    meta: addj_7znvj_VCqp54ICfvvN4B4_RLsjoVk_ymZBZWvbEKUMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/applications/categories/add.vue")
  },
  {
    name: "admin-applications-apps-manage-UUID",
    path: "apps/manage/:UUID()",
    meta: _91UUID_93qYdDXYHJGNXDspgYq0_piDRg92k7iPoUgBWm6MCF23sMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/applications/apps/manage/[UUID].vue")
  },
  {
    name: "admin-applications-menus-manage-UUID",
    path: "menus/manage/:UUID?",
    meta: _91_91UUID_93_93JFSyhx_wBSPPQ0Wmd7KSQdJOOoJ4oup1ZgEuOKIPhuMMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/applications/menus/manage/[[UUID]].vue")
  },
  {
    name: "admin-applications-solution-categories-add",
    path: "solution-categories/add",
    meta: add7kMmK7ERfhZw1LRIpYNq5tu_3nmhIcvJhFhtCaTTN_MMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/applications/solution-categories/add.vue")
  },
  {
    name: "admin-applications-categories-manage-ID",
    path: "categories/manage/:ID?",
    meta: _91_91ID_93_93nj3oFs0k5HwNJuX57KOcmcIgErXPjnldnYNc7pb44eEMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/applications/categories/manage/[[ID]].vue")
  },
  {
    name: "admin-applications-solution-categories-manage-UUID",
    path: "solution-categories/manage/:UUID?",
    meta: _91_91UUID_93_93UEbe7vcPyd_1qnSBGK8kqOFIJ2tdzWlqsm5J8lU6zjsMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/applications/solution-categories/manage/[[UUID]].vue")
  }
]
  },
  {
    name: businessrulesU1MicEC0Bdgi68wOLQXiurZwaDOEVJvpg3joj6W_y7EMeta?.name,
    path: "businessrules",
    meta: businessrulesU1MicEC0Bdgi68wOLQXiurZwaDOEVJvpg3joj6W_y7EMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules.vue"),
    children: [
  {
    name: "admin-businessrules-add",
    path: "add",
    meta: addZWlh_TuwgcWSAnnLyGz1lYalEBBLPWrOsbNsMGzhnAAMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/add.vue")
  },
  {
    name: "admin-businessrules",
    path: "",
    meta: index2mGv_QweC3T6UfjEtC_X8Uk36OLLv7fpuhf_FPOYJrIMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/index.vue")
  },
  {
    name: "admin-businessrules-UUID",
    path: ":UUID()",
    meta: _91UUID_93x7XP0S_Q00Jn8oj5g6LCkbfXVPxJfOPuq0lz3v2PfS8Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID].vue"),
    children: [
  {
    name: "admin-businessrules-UUID-edit",
    path: "edit",
    meta: editEWbEr2LzOjwO4pjw5upURUijQ78Cgl8gifwTRGvzW1QMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit.vue"),
    children: [
  {
    name: "admin-businessrules-UUID-edit-kpis",
    path: "kpis",
    meta: kpis2iyHR3ulhd_KqCkB7Po1GGFp_erUTQuOzz_VsHzDDH4Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/kpis.vue")
  },
  {
    name: "admin-businessrules-UUID-edit-settings",
    path: "settings",
    meta: settingsGfEeCQWffAgZn9r4ns1Lu3KshEnWFbxrF2YOFYi3hM8Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/settings.vue")
  },
  {
    name: "admin-businessrules-UUID-edit-developer",
    path: "developer",
    meta: developerjNtNB3lei8RangaQG6lA97zBeFUpeZKjgmkKtGDzwRIMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/developer.vue")
  },
  {
    name: "admin-businessrules-UUID-edit-rest-apis",
    path: "rest-apis",
    meta: indexcVqu2H4795euw01T_o9qq6dxXpuOZ4RxPN9vnt3UfhwMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/rest-apis/index.vue")
  },
  {
    name: "admin-businessrules-UUID-edit-customize-fields",
    path: "customize-fields",
    meta: customize_45fields6_dcXkv_vrgPXgAbRegKl_g3aBiC7V_auRn6n6kOpiIMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/customize-fields.vue")
  },
  {
    name: "admin-businessrules-UUID-edit-rest-apis-restUUID",
    path: "rest-apis/:restUUID()",
    meta: indexeTZaGEDYs1LYT9NT7J7tPjio1oYzHutQ6tgnX8L_m14Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/rest-apis/[restUUID]/index.vue")
  },
  {
    name: "admin-businessrules-UUID-edit-rest-apis-restUUID-rules",
    path: "rest-apis/:restUUID()/rules",
    meta: rulesnW00YwocUe98E3z7GYrFj_LmvrIQoKXyQS_YTVJHJwIMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/edit/rest-apis/[restUUID]/rules.vue")
  }
]
  },
  {
    name: "admin-businessrules-UUID-overview",
    path: "overview",
    meta: overviewi6CVnEu4SKJhVOrpMPqab0zBcg4JxjPL2sK0hdByBpsMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/overview.vue"),
    children: [
  {
    name: "admin-businessrules-UUID-overview-state",
    path: ":state?",
    meta: _91_91state_93_93hffj36oGcJqhGsrm_1chy_RxIFZ3DTRohkbCaLb467wMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/overview/[[state]].vue")
  }
]
  },
  {
    name: "admin-businessrules-UUID-changelog",
    path: "changelog",
    meta: changelogXNBwGpN99OsBqHpgKYxLX5qwHneNaXb2TjTa1Bcsmi8Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/changelog.vue")
  },
  {
    name: "admin-businessrules-UUID-whitelisting",
    path: "whitelisting",
    meta: whitelistingQMZiiwXvfLexGYxjw_9gVDzCTZWd9nuNty9Euu_h8I0Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/whitelisting.vue")
  },
  {
    name: "admin-businessrules-UUID-notifications",
    path: "notifications",
    meta: notificationselX3yfQPVcvwTlT7mv_cSmD0nML29Lx77qUU2LGvG9kMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/businessrules/[UUID]/notifications.vue")
  }
]
  }
]
  },
  {
    name: external_45apisevZVpXVX2IdHXMs5iMib3oIWDEj_rdruiaaY5EB6kFYMeta?.name,
    path: "external-apis",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/external-apis.vue"),
    children: [
  {
    name: "admin-external-apis",
    path: "",
    meta: indexO_BcA4wZDZebjjKRmuXNbGQgeUhDUygObi6Ukgt66f8Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/external-apis/index.vue")
  }
]
  },
  {
    name: "admin-notifications",
    path: "notifications",
    meta: notificationsD_EJjGP_KOJ4Oau3FckBYnrjSMBlQJBbA8CJFPBN_osMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/notifications.vue"),
    children: [
  {
    name: "admin-notifications-UUID-notificationUUID",
    path: ":UUID?/:notificationUUID?",
    meta: _91_91notificationUUID_93_934rMJQSkWvbRc4b_N2IF5i9z_vOEHfvuqryZNf7sgE4wMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/notifications/[[UUID]]/[[notificationUUID]].vue")
  }
]
  },
  {
    name: package_45marketMb_YFHU4t3tLZgqdzi_hr9r_L8RjEMrQQ2SwdljulG8Meta?.name,
    path: "package-market",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/package-market.vue"),
    children: [
  {
    name: "admin-package-market",
    path: "",
    meta: indexHni84_IeDFiUPsU_aUxdvRN1MTEjHoToGe1U9d2SSuEMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/package-market/index.vue")
  },
  {
    name: "admin-package-market-packageUUID",
    path: ":packageUUID()",
    meta: indexefeZf4m5vcmNHyoERnbrSHLSQ9j1aJJ7pM_chPcKaQUMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/package-market/[packageUUID]/index.vue")
  },
  {
    name: "admin-package-market-packageUUID-details",
    path: ":packageUUID()/details",
    meta: indexxVcVmYrp5lG4h_l4Zi1yLz_h4eoPo8HhIFqysIzCj_sMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/package-market/[packageUUID]/details/index.vue")
  },
  {
    name: "admin-package-market-packageUUID-details-releaseUUID",
    path: ":packageUUID()/details/:releaseUUID()",
    meta: _91releaseUUID_93_SLdAHw7kLzJS_bpLgBzhcJyLTfFqXErtiMysGTvxPEMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/package-market/[packageUUID]/details/[releaseUUID].vue")
  }
]
  },
  {
    name: task_45templatesl28O6K__nHxcz85Ir4IeZcScbcJvW6gHxOMq3BNE8XYMeta?.name,
    path: "task-templates",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/task-templates.vue"),
    children: [
  {
    name: "admin-task-templates",
    path: "",
    meta: indexddCZvkA2fhvbWFxm1LyGteWKWWxCM_MZbSyk1h_1xwMMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/task-templates/index.vue")
  },
  {
    name: "admin-task-templates-UUID",
    path: ":UUID()",
    meta: _91UUID_9373Np0_V7RUDkWpPPSNQYhg49Zz7ftv6ndMnWKdByOR8Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/task-templates/[UUID].vue")
  },
  {
    name: "admin-task-templates-add-task-template",
    path: "add-task-template",
    meta: add_45task_45templateH092__wVyt8baa3J9jYC7uBqpWmTks1S7qgGps6EnPwMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/task-templates/add-task-template.vue")
  }
]
  },
  {
    name: endpoint_45serverszcry6DMzWCOdKbgHgCfKC_BwLbrtsSmIMl_P_161RcEMeta?.name,
    path: "endpoint-servers",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/endpoint-servers.vue"),
    children: [
  {
    name: "admin-endpoint-servers",
    path: "",
    meta: indexanyg1NE_EF_oRI4KcnGScBRWta3RzSNjBy6kXJaeLAwMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/endpoint-servers/index.vue")
  },
  {
    name: "admin-endpoint-servers-UUID",
    path: ":UUID()",
    meta: _91UUID_93pg_zAj1dG0poGE9A4MasaRpeWIpeRfY07ujDVXJC0S4Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/endpoint-servers/[UUID].vue")
  },
  {
    name: "admin-endpoint-servers-add-server",
    path: "add-server",
    meta: add_45serverbkPf390xrrsc7GiF1gKIpsVqDfjnXz_wOoYAsahUh50Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/endpoint-servers/add-server.vue")
  },
  {
    name: "admin-endpoint-servers-add-file-server",
    path: "add-file-server",
    meta: add_45file_45serverIPl1ciKjKiwx0k_Z8qZbj6luJYQEnu68tAZPN5cEg_wMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/endpoint-servers/add-file-server.vue")
  }
]
  },
  {
    name: system_45variablesN__bNVN72neG8wsstoNhVNcSfsWYpRttEwH4uL5K6_0Meta?.name,
    path: "system-variables",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/system-variables.vue"),
    children: [
  {
    name: "admin-system-variables",
    path: "",
    meta: indexJCmyzabKbErBUCJdgBD6VtUQduhvuHQS8YaC9175_XsMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/system-variables/index.vue")
  }
]
  },
  {
    name: "admin-force-logout",
    path: "force-logout",
    meta: indexB7RRmvM8bTWsHIfHbv_zjIOLE5VoBaNUxzW94SvF_PQMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/force-logout/index.vue")
  },
  {
    name: snapshots_45progress5tvlyTOyWQ_cQw8fLVEO83zgKEdcQezf43VPJvLy_XsMeta?.name,
    path: "snapshots-progress",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/snapshots-progress.vue"),
    children: [
  {
    name: "admin-snapshots-progress",
    path: "",
    meta: indexfiLSwYzlieA6qkk2iKQnSBQalbhIbtCXX99gwqeyzkEMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/snapshots-progress/index.vue")
  }
]
  },
  {
    name: email_45configurationXVyOz0VpNFmLXki2jPr9KILGUEDWkSj7wrRfKflcTUIMeta?.name,
    path: "email-configuration",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/email-configuration.vue"),
    children: [
  {
    name: "admin-email-configuration",
    path: "",
    meta: indexcdMTnRYrCt1OHzWM1lLoD9vm9WEoYrrzuSJzAloxvAEMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/email-configuration/index.vue")
  }
]
  },
  {
    name: "admin-user-authorizations",
    path: "user-authorizations",
    meta: user_45authorizationsSblA1eaRfhoHk8F1JYthnmryH24Hg_9tuT6GOMoBzxwMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/user-authorizations.vue"),
    children: [
  {
    name: "admin-user-authorizations-tab",
    path: ":tab()",
    meta: indexiTbpCfJwx9fJZJln4whb5WCGG0NX7hBoynMpLlJ73yEMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/user-authorizations/[tab]/index.vue")
  },
  {
    name: "admin-user-authorizations-users-add-user",
    path: "users/add-user",
    meta: add_45userAf0bEQd2IZf7hZWfzmxUQVAIAnHVy4txmrGLh6FagvAMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/user-authorizations/users/add-user.vue")
  },
  {
    name: "admin-user-authorizations-users-import-user",
    path: "users/import-user",
    meta: import_45userjmJu3yJtu5Pq0ZYHAlriy3IVIDs72VtuWoxOUpF7HcUMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/user-authorizations/users/import-user.vue")
  },
  {
    name: "admin-user-authorizations-users-manage-id",
    path: "users/manage/:id()",
    meta: _91id_937WVgdYimAAH5G23D9TCUFWX3Ntlc__xerR7LG6hzozIMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/user-authorizations/users/manage/[id].vue")
  },
  {
    name: "admin-user-authorizations-users-change-logs-id",
    path: "users/change-logs/:id()",
    meta: _91id_93L0fbThMhYw_k5vZPP6JVW8lvrL5gaJ3nOTW_ISYg_4EMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/user-authorizations/users/change-logs/[id].vue")
  }
]
  },
  {
    name: "admin-application-insights",
    path: "application-insights",
    meta: application_45insightsAcI8LIYADYuuvqarFCtJTZ0g1Jxbx0_RhG_j8zMNbNIMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/application-insights.vue")
  },
  {
    name: application_45packageslqEqz_c0OJAOMj1WhKWmsa6Fmx4MV_rINL38d_07_LYMeta?.name,
    path: "application-packages",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/application-packages.vue"),
    children: [
  {
    name: "admin-application-packages",
    path: "",
    meta: index6aaf_ZtMhIn7JsGwASOzQ9nLQwy33A0N_0nZ7rcFWHEMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/application-packages/index.vue")
  },
  {
    name: "admin-application-packages-uuid",
    path: ":uuid()",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/application-packages/[uuid].vue"),
    children: [
  {
    name: "admin-application-packages-uuid-manage",
    path: "manage",
    meta: managenTOBQpicPpJ_eHe_KQJ9yEfNUWuh6YQ0EAH5tcb9BM0Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/application-packages/[uuid]/manage.vue")
  },
  {
    name: "admin-application-packages-uuid-tab",
    path: ":tab()",
    meta: indexJNaLflm4Tgw_qtTZtHY19x0Now1_fhn_pg3pTTVRrLgMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/application-packages/[uuid]/[tab]/index.vue")
  },
  {
    name: "admin-application-packages-uuid-tab-action",
    path: ":tab()/:action()",
    meta: _91action_93u8zh5PiXKqUs_TYwSRVRJdzoz81P0Ya_GS_NdyoHcJUMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/application-packages/[uuid]/[tab]/[action].vue")
  }
]
  },
  {
    name: "admin-application-packages-add-application-package",
    path: "add-application-package",
    meta: add_45application_45packageuI48JSoQGkFExMOdHwFt8N6VQAWGzOFvFgqeXf8nm5kMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/application-packages/add-application-package.vue")
  }
]
  },
  {
    name: "admin-scim-ip-whitelisting",
    path: "scim-ip-whitelisting",
    meta: scim_45ip_45whitelistingOCkK70Oqs4Lu_zhu5LpvRUWYR44TkExvr8VbQzqWrWsMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/scim-ip-whitelisting.vue")
  },
  {
    name: notification_45templatee70iHKoO8mdhwdZgt4kwrs_2RiOmwTwH0v9BOc8ZGuMMeta?.name,
    path: "notification-template",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/notification-template.vue"),
    children: [
  {
    name: "admin-notification-template",
    path: "",
    meta: indexKr6nWQfkf4XqqWRzNqLOUfWh8iUWFaPLPJjolCv8SO4Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/notification-template/index.vue")
  },
  {
    name: "admin-notification-template-UUID",
    path: ":UUID()",
    meta: _91UUID_93ukmYj_zxZOrYX11PbemjWDhw2_8KzO2WE60d1mCWj5YMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/notification-template/[UUID].vue")
  },
  {
    name: "admin-notification-template-add-template",
    path: "add-template",
    meta: add_45templatebnX21WW_Ubgpc500mjGbLjiOqBhqkpX0r_aDZ5ggJB0Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/notification-template/add-template.vue")
  }
]
  },
  {
    name: "admin-workflow-trigger-log",
    path: "workflow-trigger-log",
    meta: indexuzn4rHQE9f_lRmo074lRzwkv6hKNKfBg0sBTX_UeCUgMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/workflow-trigger-log/index.vue")
  },
  {
    name: "admin-container-applications",
    path: "container-applications",
    meta: indexqNaq3Za9XN9gM9zOuZTHtVIJyXdFr6zo2_HS9PVpn4wMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/container-applications/index.vue")
  },
  {
    name: "admin-data-export-endpoint-servers",
    path: "data-export-endpoint-servers",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/admin/data-export-endpoint-servers.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginLK8XeIG20n_5_dFWbuqLvmfwaVlpbGfL_rRVIwbkY8YMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/login.vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    meta: tasksjqFH0H9SzHQIFKell_Ab3lyRDF_tnXLYxSFR2Gd8qNUMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/tasks.vue"),
    children: [
  {
    name: "tasks-my",
    path: "my",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/tasks/my.vue")
  },
  {
    name: history975aIGhaO80JoTc1VwG_2bqakEGsWBdTYoBI3y94FAsMeta?.name,
    path: "history",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/tasks/history.vue"),
    children: [
  {
    name: "tasks-history",
    path: "",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/tasks/history/index.vue")
  }
]
  }
]
  },
  {
    name: "logout",
    path: "/logout",
    meta: logout2xzEm2N9FcSy1K1_RamLoJLymS_56CLALYUm1KTiebQMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/logout.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/[...slug].vue")
  },
  {
    name: "launchpad",
    path: "/launchpad",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/launchpad.vue")
  },
  {
    name: "verify-otp",
    path: "/verify-otp",
    meta: verify_45otpNtHsB53goHQgmsNclcTK8ZbLHfxeJ8ibSWKUywFALV8Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/verify-otp.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenanceozR1FB_3KCde8v17Q9n3cpN8w1ihyNnBpWCy6ZUjIPoMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/maintenance.vue")
  },
  {
    name: "wizard-url",
    path: "/wizard/:url()",
    meta: _91url_93G6_p1OaUN5xAJjxq03J3m11PoeI5ZsGlRmVc1iD8f_8Meta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/wizard/[url].vue"),
    children: [
  {
    name: "wizard-url-recordUUID",
    path: ":recordUUID()",
    meta: _91recordUUID_93GWRLQ9yZqmfI7H5_IBOVVu9BnNmYQqZfIc_Ut76hADgMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/wizard/[url]/[recordUUID].vue"),
    children: [
  {
    name: "wizard-url-recordUUID-phase-step-mode",
    path: ":phase?/:step?/:mode?",
    meta: _91_91mode_93_93WqLNY3i6A5bGxigeSlkXfzWXu795T9_hZxh5QeoY8QgMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/wizard/[url]/[recordUUID]/[[phase]]/[[step]]/[[mode]].vue")
  }
]
  }
]
  },
  {
    name: "not-authorized",
    path: "/not-authorized",
    component: () => import("/azp/agent/_work/11/s/frontend/pages/not-authorized.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordfbmidRnbmFuEb05enknQfKmCBtszx97g1uer7R4TljcMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/reset-password.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45password4lk0QOH91GqzrsC5_ttOimucZQuun5WsvxJXApTRxLAMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/forgot-password.vue")
  },
  {
    name: "form-url",
    path: "/form/:url()",
    meta: indexucSf6HzXj9cxY1RI5U8Vt3JeFFBEyry0InrkL4Em_2AMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/form/[url]/index.vue")
  },
  {
    name: "widgets-analyze-UUID",
    path: "/widgets/analyze/:UUID()",
    meta: _91UUID_93OogU_xIWrUx1XV16W5NDpGYU67cpAz_8rVklN_FL3WEMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/widgets/analyze/[UUID].vue")
  },
  {
    name: _91tenantEntryUUID_93mIAIPMXNuKNMzAC3Z0fD5pgfTFIDwldKZM0I867sVYEMeta?.name,
    path: "/form/:url()/:tenantEntryUUID()",
    meta: _91tenantEntryUUID_93mIAIPMXNuKNMzAC3Z0fD5pgfTFIDwldKZM0I867sVYEMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/form/[url]/[tenantEntryUUID].vue"),
    children: [
  {
    name: "form-url-tenantEntryUUID",
    path: "",
    meta: index4eVu9AEwjDWJ6NcJxbfCahholk_bQdT33059vpWgiPEMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/form/[url]/[tenantEntryUUID]/index.vue")
  },
  {
    name: "form-url-tenantEntryUUID-recordUUID",
    path: ":recordUUID()",
    meta: _91recordUUID_93XOjmM8t_CKBtNz9lpiCbNPf402_fv2JuIQ7eUvNnnDgMeta || {},
    component: () => import("/azp/agent/_work/11/s/frontend/pages/form/[url]/[tenantEntryUUID]/[recordUUID].vue")
  }
]
  }
]